import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getImageStylesAndSrc } from './helpers';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
const ImageMonoHtmlView = (props)=>{
    const { deviation, width: propsWidth, config } = props;
    const calculatedProps = getImageStylesAndSrc(deviation, propsWidth, config);
    if (!calculatedProps) {
        return null;
    }
    const { wrapperStyles, coverThumb, imgStyles } = calculatedProps;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: config.link,
        deviation: deviation,
        className: getThumbGlobalClassNames(deviation)
    }, /*#__PURE__*/ React.createElement("div", {
        style: wrapperStyles,
        className: classnames('daeditor-image-mono', getThumbGlobalClassNames(deviation), props.config && props.config.alignment && `daeditor-align-${props.config.alignment}`, props.settings && props.settings.showMediaAlwaysSmall && `daeditor-small`, props.config.size === 'fullWidth' ? 'daeditor-full-width' : 'daeditor-best-fit')
    }, /*#__PURE__*/ React.createElement("img", {
        src: cleanLinkSrc(coverThumb.src),
        style: imgStyles,
        alt: deviation.title,
        loading: "lazy"
    })));
};
ImageMonoHtmlView.displayName = 'ImageMonoHtmlView';
export default ImageMonoHtmlView;

//# sourceMappingURL=ImageHtml.js.map